const v = require('./vocabulary.json');

const MATERIALS = v.materials;
const GRADES = v.grades;
const FINDING_TYPES = v.findingTypes;
const SEVERITIES = v.severities;
const DEVICE_TYPES = v.deviceTypes;
/** The fixtures of a commercial restroom or kitchen: dispensers, grab bars, exit signs. */
const COMMERCIAL_DEVICE_TYPES = v.commercialDeviceTypes;
/** Plumbing trim and bath accessories: shower valves, tub spouts, towel bars, paper holders. */
const FIXTURE_TRIM_TYPES = v.fixtureTrimTypes;
// Appliances and large fixtures RoomPlan has no object category for (2026-10-12).
const APPLIANCE_DEVICE_TYPES = v.applianceDeviceTypes;
const LIGHT_SUBTYPES = v.lightSubtypes;
const CONFIDENCES = v.confidences;
const STYLE_ERAS = v.styleEras;
const LOOKS = v.looks;
const STYLE_VERDICTS = v.styleVerdicts;
const STYLE_CUES = v.styleCues;

/**
 * Which material list an OBJECT answers from, by its RoomPlan / pipeline type. An
 * object used to answer with the countertop classes whatever it was, so a toilet, a
 * fridge and a dresser all came back `other` (first calibration, 2026-10-06: every
 * storage unit and every toilet on two houses). A type not listed here answers from
 * the countertop lists when it says counter and the fixture lists otherwise.
 */
const OBJECT_MATERIAL_KINDS = v.objectMaterialKinds;
const DEVICE_FINISHES = v.deviceFinishes;

/**
 * The material-list key a target answers from: a surface's own kind, an object's by
 * its type. `null` for a surface kind with no list. The same rule as the depth
 * service's `material_vocab_key`.
 */
function materialKindFor(kind, objectType = null) {
  if (kind !== 'object') return MATERIALS[kind] ? kind : null;
  const type = objectType || '';
  return (
    OBJECT_MATERIAL_KINDS[type] ||
    (type.toLowerCase().includes('counter') ? 'countertop' : 'fixture')
  );
}

function isMaterialFor(kind, cls) {
  return Array.isArray(MATERIALS[kind]) && MATERIALS[kind].includes(cls);
}

function isLookFor(kind, look) {
  return Array.isArray(LOOKS[kind]) && LOOKS[kind].includes(look);
}

module.exports = {
  MATERIALS,
  GRADES,
  FINDING_TYPES,
  SEVERITIES,
  DEVICE_TYPES,
  COMMERCIAL_DEVICE_TYPES,
  FIXTURE_TRIM_TYPES,
  APPLIANCE_DEVICE_TYPES,
  LIGHT_SUBTYPES,
  CONFIDENCES,
  STYLE_ERAS,
  LOOKS,
  STYLE_VERDICTS,
  STYLE_CUES,
  OBJECT_MATERIAL_KINDS,
  DEVICE_FINISHES,
  materialKindFor,
  isMaterialFor,
  isLookFor,
};
